import { loadFont } from "@remotion/google-fonts/NotoSansJP";

const { fontFamily } = loadFont("normal", {
  weights: ["400", "500", "700"],
});

export const FONT_FAMILY = fontFamily;
